export default __webpack_public_path__ + "static/ISO-14001-b6dbedcd32bbff8dd8edfb5bbbb1ceaf.png";